import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import SmallSpinner from "../loading/SmallSpinner.js";
import Dropzone1 from "../dropzones/DropZone1.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import uploadDropZoneTemporary from "../api/upload/uploadDropZoneTemporary.js";
import transferInvoiceOutsideSigned from "../api/folder/transferInvoiceOutsideSigned.js";

const DropSignedDevis = ({ orgData, invoiceData, onClose, handleRefresh }) => {
  const [dropped_files, setDroppedFiles] = useState([]);
  const [dropped_exists, setDroppedExists] = useState(false);
  const [loading_drop, setLoadingDrop] = useState(false);
  const [loadingData = false, setLoadingData] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  useEffect(() => {}, [orgData]);

  const onDropZone = async (files) => {
    setLoadingDrop(true);

    let new_files = [];
    const token = await getOrRefreshFirebaseToken();

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i].name,
        prefix
      );
      let url = res.url;
      let name = res.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  const onDelete = (file) => {
    const new_files = dropped_files.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
  };

  const transferFiles = async () => {
    try {
      const token = await getOrRefreshFirebaseToken();
      await transferInvoiceOutsideSigned(
        invoiceData.id,
        dropped_files,
        token,
        prefix
      );
      handleClickVariant("Devis signé transféré avec succès", "success");
      handleRefresh();
      setDroppedFiles([]);
      setDroppedExists(false);
      onClose();
    } catch (error) {
      console.error("Error transfering files:", error);
    }
  };

  return (
    <div className="flex flex-col bg-white rounded-3xl p-4">
      <div className="w-c300 text-h3 flex flex-row justify-between">
        Déposer le devis signé
        <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>
      <Space y={5} />

      <div className="w-c300 text-h3 text-shadow_50">
        Vous avez la possibilité de faire signer le devis en dehors d'hexagone
        et de le déposer ici.
      </div>
      <Space y={15} />
      <Dropzone1
        onDrop={onDropZone}
        files={dropped_files || []}
        onDelete={onDelete}
        loading={loading_drop}
        instructionsText="Glissez ou déposez les documents ici"
        mandatory={!dropped_exists}
      ></Dropzone1>
      <Space y={20} />

      <PrimaryButton onClick={transferFiles} disabled={loadingData}>
        Confirmer la validité de la signature{" "}
        <SmallSpinner loading={loadingData} />
      </PrimaryButton>
    </div>
  );
};

export default DropSignedDevis;
